const prod = {
	url: {
		API_URL: 'https://website-feedback.com/api/',
		BASE_URL: 'https://website-feedback.com/',
		IMAGE_URL: 'https://website-feedback.com/uploads/'
	}
};
const dev = {
	url: {
	  	API_URL: 'https://website-feedback.com/api/',
	  	BASE_URL: 'https://website-feedback.com/',
	  	IMAGE_URL: 'https://website-feedback.com/uploads/'
	}
};
export const config = process.env.NODE_ENV === 'development' ? dev : prod;